import React, { useCallback, useMemo } from "react";
import "./WordsHistory.css";
import { useDispatch, useSelector } from "react-redux";
import {
  SetSliderValue,
  SetUrlPrefix,
  SetImgPrefix,
  SetSliderValueMinMax,
  SetIsExpanded,
  SetIsSearching,
  SetSearchWord,
  SetPrevProducts,
  SetAsyncData,
  SetListingBanner,
  SetProducts,
  SetResultsCount,
  SetFilters,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords,
  SetWordsHistory,
} from "../../state/actions/index";
import Utils from "../../utils/Utils";
import axios from "axios";
import Cookies from "universal-cookie";
import PerfectScrollbar from "react-perfect-scrollbar";

const WordsHistory = () => {
  const wordsHistory = useSelector((state) => state.wordsHistory);
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  );
  const filters = useSelector((state) => state.config.filters);
  const triggers = useSelector((state) => state.config.triggers);
  const placeholders = useSelector((state) => state.config.placeholders);
  const card = useSelector((state) => state.config.card);
  const isMobile = useSelector((state) => state.isMobile);
  const sort = useSelector((state) => state.sort);
  const products = useSelector((state) => state.products);
  const activeFilters = useSelector((state) => state.activeFilters);
  const config = useSelector((state) => state.config);
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax);
  const sliderValue = useSelector((state) => state.sliderValue);
  const seoSettings = useSelector((state) => state.config.seoSettings);
  const cookies = new Cookies();
  const dispatch = useDispatch();

  const queryOptions = useSelector((state) => state.config.queryOptions);
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  );

  const categoryKey = useMemo(() => {
    var valueToReturn = "";
    Object.keys(filters).forEach((filter) => {
      if (filters[filter].isCategory) valueToReturn = filter;
    });
    return valueToReturn;
  }, [filters]);

  const onWordClick = useCallback(
    (word) => {
      dispatch(SetSearchWord(word));
      if (localStorage.getItem("isSeoUrlActive") === "true") {
        window.history.pushState(
          {},
          "Filter",
          `/#/${seoSettings?.searchWord}/?query=${word}`
        );
      }
      dispatch(SetIsSearching(true));
      dispatch(SetAsyncData([]));
      var priceGroup = {};
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id;
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency;
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      );
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            word,
            activeFilters,
            sort,
            1,
            filters,
            rows
          )
        )
        .then((res) => {
          var response = res.data;
          dispatch(SetIsExpanded({}));
          dispatch(SetPrevProducts(products));
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                response.data,
                response.header.imagePrefix,
                response.header.urlPrefix,
                card.img,
                card.url
              )
            )
          );
          dispatch(SetSuggestedWords(response.suggestions));
          dispatch(SetResultsCount(response.header.results_count));
          dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)));
          dispatch(
            SetSliderValueMinMax(
              Utils.addSliderValue(response, sliderValueMinMax)
            )
          );
          dispatch(SetFilters(response));
          dispatch(
            SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
          );
          dispatch(SetPage(1));
          dispatch(SetListingBanner(response.banners[0]));
          dispatch(
            SetMasterCategories(
              response.stats[categoryKey]
                ? Utils.refactorMasterCategories(
                    Object.keys(response.stats[categoryKey])
                  )
                : defaultMasterCategories
            )
          );
          dispatch(SetUrlPrefix(response.header.urlPrefix));
          dispatch(SetImgPrefix(response.header.imagePrefix));
          if (config.webhook.key !== "")
            Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
              (value) => dispatch(SetAsyncData(value.asyncData))
            );
        })
        .finally(() => dispatch(SetIsSearching(false)));
    },
    [
      dispatch,
      activeFilters,
      sort,
      sliderValue,
      sliderValueMinMax,
      config,
      defaultMasterCategories,
      filters,
      products,
      rows,
      categoryKey,
      card,
    ]
  );

  var wordsHistoryResponsive = useMemo(
    () =>
      isMobile ? triggers.wordsHistory.mobile : triggers.wordsHistory.desktop,
    [triggers, isMobile]
  );
  const cookieMaxAge = useMemo(() => {
    switch (wordsHistoryResponsive.timeframe) {
      case "1D":
        return 86400;
      case "1W":
        return 604800;
      case "1Y":
        return 31536000;
      default:
        return 86400;
    }
  }, [wordsHistoryResponsive]);

  const onIconClick = useCallback(
    (item) => {
      var words = cookies.get("ASWordsHistory");
      var wordsToHandle = [...words];
      var indexToSplice = wordsToHandle.indexOf(item);
      wordsToHandle.splice(indexToSplice, 1);
      cookies.set("ASWordsHistory", JSON.stringify(wordsToHandle), {
        maxAge: cookieMaxAge,
      });
      dispatch(SetWordsHistory(wordsToHandle));
    },
    [cookies, cookieMaxAge, dispatch]
  );

  return (
    <div className="history-words">
      <div className="label"> {placeholders.lastSearches} </div>
      {!isMobile ? (
        <div className="history-words-list">
          {(wordsHistory ? wordsHistory : []).reverse().map((item, index) => (
            <div className="history_word_item" key={"history_word_" + index}>
              <span className="item" onClick={() => onWordClick(item)}>
                {" "}
                {item}{" "}
              </span>
              <span className="icon" onClick={() => onIconClick(item)}>
                {" "}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <PerfectScrollbar className="history-words-list">
          {(wordsHistory ? wordsHistory : []).reverse().map((item, index) => (
            <div className="history_word_item" key={"history_word_" + index}>
              <span className="item" onClick={() => onWordClick(item)}>
                {" "}
                {item}{" "}
              </span>
              <span className="icon" onClick={() => onIconClick(item)}>
                {" "}
              </span>
            </div>
          ))}
        </PerfectScrollbar>
      )}
    </div>
  );
};

export default WordsHistory;
